import { createContext, useContext } from 'react';

export type Theme = 'dark' | 'light';

export type ThemeProviderState = {
  theme: Theme;
  setTheme: (theme: Theme, origin?: { x: number; y: number }) => void;
};

export const initialState: ThemeProviderState = {
  theme: 'light',
  setTheme: () => null,
};

export const ThemeProviderContext = createContext<ThemeProviderState>(initialState);

export const useTheme = () => {
  const context = useContext(ThemeProviderContext);
  if (context === undefined) throw new Error('useTheme must be used within a ThemeProvider');
  return context;
};
